<template>
  <div>
    <div class="formList">
      <el-card class="box-card" v-for="(item,index) in formData" :key="index">
        <div slot="header" class="clearfix">
          <span>{{item.name}}</span>
          <span>{{item.phone}}</span>
          <el-button type="danger" size="mini" :class="item.type=='患者'?'red':'purple'">{{item.type}}</el-button>
          <el-button type="primary" size="mini" v-if="item.flat">{{item.flat}}</el-button>
        </div>
        <div>
          <div class="formItem">
            <div class="waitTime">等待时间:{{item.waitTime}}</div>
            <el-button type="primary" size="mini">更换客服</el-button>
          </div>
          <div class="formSpan">
            <span>客服:{{item.name}}</span>
            <span>现场:{{item.name}}</span>
            <span>助理:{{item.name}}</span>
          </div>
        </div>
      </el-card>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: [
        {
          name: '张三',
          phone: '15245487896',
          type: '患者',
          flat: 'VIP',
          time: "2022-08-18 09:27:56",
          waitTime: '2分30秒'
        },
        {
          name: '李四',
          phone: '15245487896',
          type: '患者',
          flat: '',
          time: "2022-08-18 09:27:56",
          waitTime: '未开始'
        },
        {
          name: '刘哈',
          phone: '15245487896',
          type: '陪同',
          flat: '',
          time: "2022-08-18 09:27:56",
          waitTime: '2分30秒'
        },
        {
          name: '刘哈',
          phone: '15245487896',
          type: '陪同',
          flat: '',
          time: "2022-08-18 09:27:56",
          waitTime: '2分30秒'
        },
        {
          name: '刘哈',
          phone: '15245487896',
          type: '陪同',
          flat: '',
          time: "2022-08-18 09:27:56",
          waitTime: '未开始'
        },

      ]

    }
  }

}
</script>
<style scoped>
.box-card {
  margin: 5px;
  width: calc((100% - 50px) / 4);
  min-width: calc((100% - 50px) / 4);
  max-width: calc((100% - 50px) / 4);
}
.red {
  background: red;
}
.purple {
  background: #6d83e4;
}
.waitTime {
  font-size: 14px;
}
.formItem {
  /* border: 1px solid red; */
  display: flex;
  justify-content: space-between;
}
.formList {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.formSpan {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 8px;
}
</style>